<script setup>
const {
    pinValue = undefined,
    pingType = 'primary',
    animatePing = false,
    position = 'right',
} = defineProps({
    pinValue: {
        type: [Number, String],
        required: false,
    },
    pingType: {
        type: String,
        required: false,
    },
    animatePing: {
        type: Boolean,
        required: false,
    },
    position: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        v-if="pinValue !== undefined"
        class="absolute -top-1 flex h-5 min-w-5"
        :class="{
            '-right-1': position === 'right',
            '-left-1': position === 'left',
        }"
    >
        <span
            class="absolute inline-flex h-full w-full rounded-full opacity-75"
            :class="{
                'bg-indigo-300': pingType === 'primary',
                'bg-red-300': pingType === 'danger',
                'bg-yellow-300': pingType === 'warning',
                'bg-green-300': pingType === 'success',
                'animate-ping': animatePing,
            }"
        >
        </span>
        <span
            class="relative inline-flex h-5 min-w-5 items-center justify-center rounded-full border border-white px-1 text-xs text-white"
            :class="{
                'bg-indigo-600': pingType === 'primary',
                'bg-red-500': pingType === 'danger',
                'bg-yellow-500': pingType === 'warning',
                'bg-green-500': pingType === 'success',
            }"
        >
            {{ pinValue }}
        </span>
    </div>
</template>
